<template>
  <button
    v-show="isVisible"
    class="slide-up"
    type="button"
    aria-label="Наверх"
    @click="scrollToTop"
  >
    <span class="slide-up__arrow"></span>
    <span>Наверх</span>
  </button>
</template>

<script>
export default {
  name: 'scroll-to-top',
  data: () => ({
    isVisible: false
  }),
  mounted() {
    this.updateVisibility()
    window.addEventListener('scroll', this.updateVisibility, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateVisibility)
  },
  methods: {
    updateVisibility() {
      this.isVisible = window.scrollY > 600
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
